module.exports = __webpack_public_path__ + "static/SacramentoRegular-c3264a2601f855aef183e1892c5504db.ttf";